export default {"src":"/_next/static/media/logo_ac.3b332368.svg","height":39,"width":130,"blurWidth":0,"blurHeight":0};